const USER_LOCALSTORAGE_KEY = 'userData';

// helper to get user from localstorage
export function getStoredUser() {
  if (typeof window !== 'undefined') {
    const storedUser = localStorage.getItem(USER_LOCALSTORAGE_KEY) || false;
    return storedUser ? JSON.parse(storedUser) : null;
  }
}

export function setStoredUser(user) {
  if (typeof window !== 'undefined') {
    localStorage.setItem(USER_LOCALSTORAGE_KEY, JSON.stringify(user)) || false;
  }
}

export function clearStoredUser() {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(USER_LOCALSTORAGE_KEY) || false;
  }
}
